import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { Office, City } from '../../../shared/models/missingdata.model';
import { OfficeService } from '../../../shared/_services/office.service';
import { CityService } from '../../../shared/_services/city.service';

@Component({
  selector: 'app-table-offices',
  templateUrl: './table-offices.component.html',
  styleUrls: ['../admin-tables.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)',
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          transform: 'translateX(100%)'
        }))
      ])
    ])
  ]
})
export class TableOfficesComponent implements OnInit {

  SearchTerm: string;
  List: Office[];
  List2: City[];
  NewElement: Office;
  saveElement: Office[] = [];
  FormNew = false;
  error: string;
  message: string;

  idSelected: number = -1;

  constructor(
    private officeService: OfficeService,
    private cityService: CityService
  ) { }

  ngOnInit() {
    this.cityService.getCities()
      .subscribe((res: City[]) => {
        this.List2 = res;
        this.officeService.getOffices()
          .subscribe((lista: Office[]) => {
            this.List = lista;
          }, err => console.log(err))
      }, err => console.log(err))
  }

  cleanMessage() {
    this.message = undefined;
    this.error = undefined;
    this.saveElement = [];
  }

  onKeyUp(value) {
    this.SearchTerm = value;
  }
  
  toggleNew() {
    this.NewElement = new Office;
    this.FormNew = !this.FormNew;
  }

  add() {
    this.cleanMessage();
    if (this.NewElement) {
      this.NewElement.fkIdCity = this.idSelected;
      this.saveElement.push(this.NewElement);
      this.officeService.saveOffices(this.saveElement)
        .subscribe(res => {
          this.List.push(this.NewElement);
          this.List.sort((a, b) => a.idOffice < b.idOffice ? -1 : a.idOffice > b.idOffice ? 1 : 0);
          this.FormNew = false;

          this.message = "Elemento agregado correctamente";
        }, err => this.error = err
      )
    }
  }  

  changeValue(idOffice: any) {
    this.cleanMessage();
    let name = "[date-office ='" + idOffice +"']";
    document.querySelectorAll(name).forEach(function (element) {
      element.removeAttribute("readonly");
    })
    document.getElementsByName("btgrnoffice-" + idOffice)[0].removeAttribute("hidden");

    document.getElementsByName("btednoffice-" + idOffice)[0].setAttribute("hidden","hidden");
  }

  updateList(idOffice: any) {
    this.cleanMessage();
    let name = "[date-office = '" + idOffice + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.setAttribute("readonly", "readonly");
    });

    //console.log(this.List.find(t => t.idOffice == idOffice));

    this.officeService.updateOffice(this.List.find(t => t.idOffice == idOffice))
      .subscribe(res => {
        document.getElementsByName("btednoffice-" + idOffice)[0].removeAttribute("hidden");
        document.getElementsByName("btgrnoffice-" + idOffice)[0].setAttribute("hidden", "hidden");
      }, err => this.error = err)

  }

  cityName(fkIdCity: number) {
    return this.List2.find(u => u.idCity == fkIdCity).cityName;
  }

}
